import { render, staticRenderFns } from "./ConfigurationStockWasteReasons.vue?vue&type=template&id=63fe9a4c&"
import script from "./ConfigurationStockWasteReasons.vue?vue&type=script&lang=js&"
export * from "./ConfigurationStockWasteReasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports